/* src/app/warehousing/pages/stock-movements/stock-movements.component.scss */
/*# sourceMappingURL=stock-movements.component.css.map */
